import { render } from "./nurse_notes_modal.vue?vue&type=template&id=a8a036ca&scoped=true"
import script from "./nurse_notes_modal.vue?vue&type=script&lang=js"
export * from "./nurse_notes_modal.vue?vue&type=script&lang=js"

import "./nurse_notes_modal.vue?vue&type=style&index=0&id=a8a036ca&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8a036ca"]])

export default __exports__